import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

export const Message = (props) => {

    const { index, message } = props;

    const person_id = parseInt(localStorage.getItem('person_id'), 10);

    const sender = message.sender,
        checkSender = message.sender.id === person_id;

    return (
        <div className="single-message">
            <label htmlFor={index} className={`margin-none${checkSender && ' pull-right'}`}>
                <p id={index} className={`margin-none msg-conversation${checkSender ? ' sent-message ' : ' receive-message'}`}>{message.contents}</p>
                <Link to={`/members/${message.sender.id}`}>
                    <p className={`member-link ${checkSender && 'text-right'}`}>{sender.first_name}</p>
                </Link>
            </label>
        </div>
    );
};

Message.propTypes = {
    message: PropTypes.object,
    index: PropTypes.number,
}


// WEBPACK FOOTER //
// src/client/components/site/features/networking/pages/elements/Message.js